<template>
    <CRow>
        <CCol col="12" lg="8">
            <CCard>
                <CCardHeader>
                    <strong>{{ service.title }}: Создание акции</strong>
                    <RestaurantTableOrderBadge />
                </CCardHeader>
                <CCardBody>
                    <PromotionsTabLinks :service-name="serviceName" />
                    <CRow class="pl-3 pb-3" />
                    <CForm>
                        <CInput
                            v-model="promotion.title"
                            label="Название"
                            placeholder="Введите название акции"
                        />
                        <CSelect
                            :value.sync="promotion.type"
                            :horizontal="true"
                            :options="promotionTypes"
                            label="Тип"
                            placeholder="Выберите тип"
                        />
                        <CInput v-model="promotion.discount" label="Скидка" />
                        <CInput v-model="promotion.orders_quantity" label="Количество первых заказов в заведении по акции" />
                        <CInput v-model="promotion.entity_discount_percent" label="Размер скидки от ресторана (%)" />
                        <CInput v-model="promotion.entity_discount_sum" label="Размер скидки от ресторана (руб.)" />
                        <CInput v-model="promotion.mircity_commission" label="Размер комиссии МИРСИТИ (%)" />
                        <ScheduleUpdate :schedule="schedule" @set-schedule="setSchedule"/>
                        <CInput v-model="promotion.date_start" label="Дата начала" />
                        <CInput v-model="promotion.date_finish" label="Дата окончания" />
                        <CInput v-model="promotion.time_from" label="Время (от)" />
                        <CInput v-model="promotion.time_to" label="Время (до)" />
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Неограничено по времени
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="promotion.unlimited"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Учитывать при интеграции
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="promotion.accounting_in_integration"
                                />
                            </CCol>
                        </CRow>
                        <CRow form class="form-group">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Тип доставки</CCol>
                            <CCol sm="9">
                                <CSelect
                                    inline
                                    :value.sync="promotion.delivery_type"
                                    :options="delivery_types"
                                    placeholder="Тип доставки..."
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label"> Активен </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="promotion.enabled"
                                />
                            </CCol>
                        </CRow>
                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="create">Создать</CButton>
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack">Отмена</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import PromotionsTabLinks from '@/components/promotions/PromotionsTabLinks';
    import ScheduleUpdate from '@/components/ScheduleWorkPromotionUpdate';
    import { PROMOTION_TYPE } from '../../utils/promotion';
    const { DELIVERY_TYPE } = require('../../utils/order');
    import { promotionTypeTitle } from '../../utils/promotion-views';
    import { getRouteName, cutPlural } from '../../utils/route-name';

    export default {
        name: 'PromotionEdit',

        components: {
            PromotionsTabLinks,
            ScheduleUpdate,
        },

        data() {
            return {
                serviceName: getRouteName(this.$router.currentRoute.path),
                service: {},
                schedule: undefined,
                delivery_types: null,
                promotion: {
                    service_id: 0,
                    title: '',
                    type: null,
                    discount: 0,
                    date_start: null,
                    date_finish: null,
                    time_from: null,
                    time_to: null,
                    unlimited: false,
                    accounting_in_integration: false,
                    enabled: true,
                    common: false,
                    delivery_type: '',
                },
            };
        },

        computed: {
            promotionTypes() {
                const typeOptions = [];
                for(var prop in PROMOTION_TYPE) {
                    typeOptions.push({
                        value: PROMOTION_TYPE[prop],
                        label: promotionTypeTitle(PROMOTION_TYPE[prop])
                    })
                }
                return typeOptions;
            },
        },

        mounted() {
            const id = parseInt(this.$route.params.id);
            let url = `/${this.serviceName}/${id}`;

            if (this.serviceName === 'entities') {
                url = `/${this.serviceName}/get/${id}`
            }

            Vue.axios
                .get(url)
                .then(resp => {
                    this.service = resp.data;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });

            if(!this.delivery_types) {
                const types = [];
                types.push({ value: DELIVERY_TYPE.DOOR, label: 'До двери' });
                types.push({ value: DELIVERY_TYPE.MEETING_POINT, label: 'Место встречи' });
                types.push({ value: DELIVERY_TYPE.WITHOUT, label: 'Без доставки' });
                types.push({ value: DELIVERY_TYPE.COLLECT, label: 'Сборка заказа' });
                types.push({ value: null, label: 'Без типа доставки' });
                this.delivery_types = types;
            }
        },

        methods: {
            setSchedule(schedule) {
                this.schedule = schedule;
            },
            create() {
                if (!this.promotion.title) {
                    this.$root.$emit('showError', 'Укажите название акции.');
                    return;
                }
                if (!this.promotion.type) {
                    this.$root.$emit('showError', 'Выберите тип акции.');
                    return;
                }
                this.promotion.delivery_type === this.promotion.delivery_type;
                this.promotion[`${cutPlural(this.serviceName)}_id`] = this.service.id;
                this.promotion.discount = this.promotion.discount ? parseInt(this.promotion.discount) : 0;
                this.promotion.orders_quantity = +this.promotion.orders_quantity || null;
                this.promotion.time_from = this.promotion.time_from ? parseInt(this.promotion.time_from) : 0;
                this.promotion.time_to = this.promotion.time_to ? parseInt(this.promotion.time_to) : 0;
                this.promotion.entity_discount_percent = this.promotion.entity_discount_percent ? +this.promotion.entity_discount_percent : null;
                this.promotion.entity_discount_sum = this.promotion.entity_discount_sum ? +this.promotion.entity_discount_sum : null;
                this.promotion.mircity_commission = this.promotion.mircity_commission ? +this.promotion.mircity_commission : null;
                this.promotion.schedule = this.schedule;
                Vue.axios.post('/promotions', this.promotion)
                    .then(() => {
                        this.goBack();
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },

            goBack() {
                let path = `/${this.serviceName}/${this.service.id}/promotions`;

                if (this.serviceName === 'entities') {
                    path = `/entities/${this.$route.params.code}/${this.$route.params.id}/promotions`
                }
                this.$router.push({ path });
            },
        },
    };
</script>
